import { SelfReportedSource } from 'src/types/graphql'

/**
 * "¿Cómo nos conociste?" option sets — taxonomy + contract live server-side
 * in `spotme-server/src/api/marketing/selfReportedSource.ts`.
 *
 * Only options that answer what the pixel CAN'T see. There is deliberately
 * no "anuncio vs búsqueda" split: users can't tell paid from organic, and the
 * gclid already knows. Fixed order with "Otro" last (SSR-stable — a shuffled
 * order would mismatch hydration on the checkout success page).
 */

export type SelfReportedAudience = 'renter' | 'host'

export const SELF_REPORTED_SOURCE_OPTIONS: Record<
  SelfReportedAudience,
  readonly SelfReportedSource[]
> = {
  renter: [
    SelfReportedSource.GoogleSearch,
    SelfReportedSource.GoogleMaps,
    SelfReportedSource.AiAssistant,
    SelfReportedSource.SocialMedia,
    SelfReportedSource.Referral,
    SelfReportedSource.OtherWebsite,
    SelfReportedSource.Other
  ],
  // Hosts first: SpotMe's own supply outreach is the channel no pixel sees.
  host: [
    SelfReportedSource.SpotmeOutreach,
    SelfReportedSource.GoogleSearch,
    SelfReportedSource.SocialMedia,
    SelfReportedSource.Referral,
    SelfReportedSource.AiAssistant,
    SelfReportedSource.OtherWebsite,
    SelfReportedSource.Other
  ]
}

/** Sources that offer the optional "¿quién / qué sitio?" follow-up. */
export const DETAIL_SOURCES: ReadonlySet<SelfReportedSource> = new Set([
  SelfReportedSource.Referral,
  SelfReportedSource.OtherWebsite,
  SelfReportedSource.Other
])

/** Mirrors the server's SELF_REPORTED_SOURCE_DETAIL_MAX (it re-caps anyway). */
export const SELF_REPORTED_DETAIL_MAX = 120
